import { render, staticRenderFns } from "./otherTables.vue?vue&type=template&id=346a0e5c&scoped=true"
import script from "./otherTables.vue?vue&type=script&lang=js"
export * from "./otherTables.vue?vue&type=script&lang=js"
import style0 from "./otherTables.vue?vue&type=style&index=0&id=346a0e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a0e5c",
  null
  
)

export default component.exports